import { MarketoFormInterface } from '@lucid/gatsby-theme-lucid';

import { MarketoFormField } from 'types/types';

export const getMarketoForm = (
  marketoForms: Record<string, MarketoFormInterface>,
  fieldMarketoForm?: MarketoFormField | null
) => {
  const marketoEntity = fieldMarketoForm ? fieldMarketoForm.entity : null;
  const marketoId = marketoEntity ? marketoEntity.fieldMarketoId : null;
  const marketoForm = marketoId ? marketoForms[marketoId] : null;
  return marketoForm;
};
